<template>
  <div id="contenedor-tipos-documentos-default">
    <v-container fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <titulo-tool-bar class="mb-2" titulo="Tipos de Documentos"></titulo-tool-bar>
          <tool-bar
            class="mb-4"
            :filtros="filtros"
            v-on:nuevoTipoDocumento="registrarnuevoTipoDocumento"
            >
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <listado :listadoTiposDocumentos="getTiposDocumentos"></listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-if="mostrarVentanaRegistrarNuevoTipoDocumento"
      v-model="mostrarVentanaRegistrarNuevoTipoDocumento"
      :width="!$vuetify.breakpoint.mobile ? '50%' : '90%'">
      <registrar-nuevo-tipo-documento
        v-on:cerrar="cerrarVentana">
      </registrar-nuevo-tipo-documento>
    </v-dialog>
    <v-dialog
      v-if="esteTipoDocumento"
      v-model="mostrarVentanaEditarTipoDocumento"
      :width="!$vuetify.breakpoint.mobile ? '50%' : '90%'">
      <editar-tipo-documento
        :tipoDocumentoEditar="esteTipoDocumento"
        v-on:cerrar="cerrarVentana">
      </editar-tipo-documento>
    </v-dialog>
    <v-dialog
      v-if="esteTipoDocumento"
      v-model="mostrarVentanaEliminarTipoDocumento"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
      <eliminar-tipo-documento
        :tipoDocumentoEliminar="esteTipoDocumento"
        v-on:cerrar="cerrarVentana">
      </eliminar-tipo-documento>
    </v-dialog>
  </div>
</template>

<script>
import CATALOGO_TIPOS_DOCUMENTOS from '@/graphql/querys/administracion/catalogos/tiposdocumentos/catalogoTiposDocumentos.gql';
import TituloToolBar from '@/components/TituloToolBar.vue';
import RegistrarNuevoTipoDocumento from '@/components/administracion/configuracion/catalogos/tiposdocumentos/Nuevo.vue';
import EditarTipoDocumento from '@/components/administracion/configuracion/catalogos/tiposdocumentos/Editar.vue';
import EliminarTipoDocumento from '@/components/administracion/configuracion/catalogos/tiposdocumentos/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'CatalogoTiposDocumentosDefault',
  components: {
    TituloToolBar,
    RegistrarNuevoTipoDocumento,
    EditarTipoDocumento,
    EliminarTipoDocumento,
    ToolBar,
    Listado,
  },
  apollo: {
    catalogoTiposDocumentos: {
      query: CATALOGO_TIPOS_DOCUMENTOS,
    },
  },
  data() {
    return {
      mostrarVentanaRegistrarNuevoTipoDocumento: false,
      mostrarVentanaEditarTipoDocumento: false,
      mostrarVentanaEliminarTipoDocumento: false,
      esteTipoDocumento: null,
      filtros: {
        buscarTexto: '',
      },
    };
  },
  mounted() {
    eventBus.$on('editar-tipo-documento', (tipoDocumento) => {
      this.esteTipoDocumento = tipoDocumento;
      this.mostrarVentanaEditarTipoDocumento = true;
    });
    eventBus.$on('eliminar-tipo-documento', (tipoDocumento) => {
      this.esteTipoDocumento = tipoDocumento;
      this.mostrarVentanaEliminarTipoDocumento = true;
    });
  },
  methods: {
    registrarnuevoTipoDocumento() {
      this.mostrarVentanaRegistrarNuevoTipoDocumento = true;
    },
    cerrarVentana() {
      this.mostrarVentanaRegistrarNuevoTipoDocumento = false;
      this.mostrarVentanaEditarTipoDocumento = false;
      this.mostrarVentanaEliminarTipoDocumento = false;
      this.esteTipoDocumento = null;
    },
  },
  computed: {
    getTiposDocumentos() {
      if (!this.catalogoTiposDocumentos) return [];
      return this.catalogoTiposDocumentos
      // Filtrar por Texto de Busqueda
        .filter((tipoDocumento) => {
          if (!this.filtros.buscarTexto) return tipoDocumento;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const descripcion = this.$normalizacionTexto(tipoDocumento.descripcion);
          return (
            expt.test(descripcion)
            || expt.test(tipoDocumento.descripcion)
          );
        })
        .sort((a, b) => a.orden - b.orden);
    },
  },
};
</script>

<style lang="scss">

</style>
